import React from 'react';

import Chart, {
  CommonSeriesSettings,
  Series,
  Reduction,
  ArgumentAxis,
  Label,
  Format,
  ValueAxis,
  Title,
  Legend,
  Export,
  Tooltip,
} from 'devextreme-react/chart';

const dataSource = [{
    date: new Date(2022, 2, 1),
    l: 24,
    h: 25,
    o: 25,
    c: 24,
  }, {
    date: new Date(2022, 2, 2),
    l: 23,
    h: 25,
    o: 24,
    c: 24,
  }, {
    date: new Date(2022, 2, 3),
    l: 26,
    h: 28,
    o: 26,
    c: 27,
  }, {
    date: new Date(2022, 2, 4),
    l: 26,
    h: 27,
    o: 26,
    c: 27,
  }, {
    date: new Date(2022, 2, 7),
    l: 26.375,
    h: 27.50,
    o: 27.375,
    c: 26.75,
  }, {
    date: new Date(2022, 2, 8),
    l: 25.75,
    h: 26.875,
    o: 26.75,
    c: 26.00,
  }];
  

const CandleStickChart = () => {
    const customizeTooltip = (arg) => {
        return {
          text: `مسجل: ${arg.openValue} <br/>
    غير مسجل: ${arg.closeValue} <br/>
    مفعل: ${arg.highValue} <br/>
     غير مفعل: $${arg.lowValue} <br/>`,
        };
      }
    return (
      <Chart
        id="chart"
        
        dataSource={dataSource}
      >
        <CommonSeriesSettings
          argumentField="date"
          type="candlestick"
        />
        <Series
          name="حالة صاحب المهنة"
          openValueField="o"
          highValueField="h"
          lowValueField="l"
          closeValueField="c"
        >
          <Reduction color="red" />
        </Series>
        <ArgumentAxis workdaysOnly={true}>
          <Label format="shortDate" />
        </ArgumentAxis>
        <ValueAxis tickInterval={1}>
          <Title text="العدد الكلي" />
          <Label>
            <Format
              precision={0}
              type="decimal"
            />
          </Label>
        </ValueAxis>
        {/* <Legend itemTextPosition="center" /> */}
        <Legend verticalAlignment="top" horizontalAlignment="center"></Legend>
        <Export enabled={true} />
        <Tooltip
          enabled={true}
          location="edge"
          customizeTooltip={customizeTooltip}
        />
      </Chart>
    );
  

  
}

export default CandleStickChart;
